/**
 * よくあるご質問リアルタイム検索
 */

jQuery( function ($) {
	let originalFAQs = $('.wp-block-karankoron-blocks-faq .karankoron-block-faq__item').clone();
	let searchTimeout;
  
	function toKatakana(str) {
	  return str.replace(/[\u3041-\u3096]/g, function(match) {
		var chr = match.charCodeAt(0) + 0x60;
		return String.fromCharCode(chr);
	  }).toLowerCase();
	}
  
	function searchEvent() {
	  const results = [];
	  const inputText = toKatakana($(this).val());
  
	  // Remove existing <p> element before adding a new one
	  $('.js-faq-search-result').prev('p').remove();
  
	  clearTimeout(searchTimeout);
	  searchTimeout = setTimeout(() => {
		if (inputText) {
		  originalFAQs.each((index, faqItem) => {
			const faq = $(faqItem);
			const questionText = faq.find('.karankoron-block-faq__q').text();
			if (toKatakana(questionText).includes(inputText)) {
			  results.push(faq.clone());
			}
		  });
  
		  if (results.length > 0) {
			$('.js-faq-search-result').before(`<p>検索結果: ${results.length} 件</p>`);
			$('.js-faq-search-result').html(results);
		  } else {
			$('.js-faq-search-result').before('<p>一致する質問が見つかりませんでした。</p>');
			$('.js-faq-search-result').empty();
		  }
		} else {
		  $('.js-faq-search-result').empty();
		}
	  }, 300); // 0.5秒後に検索を開始
	}
  
	$('.js-faq-search').on('input', searchEvent);
});	
